import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import CollectionView from 'views/CollectionView';

var RenderedCollectionView = CollectionView.extend({

    initialize: function(options) {
        options = options || {};
        this.ItemView = options.ItemView || this.ItemView;
        CollectionView.prototype.initialize.apply(this, arguments);
    },

    attachSubViewWithModel: function(model, elem) {
        var subView = new this.ItemView({
            model: model
        });
        this.addSubView(subView);
        subView.setElement(elem).render();
    },

    render: function() {
        if (!this.$el.data('server-rendered')) {
            CollectionView.prototype.render.apply(this, arguments);
        } else {
            var list = this.$('[data-server-rendered]').toArray();
            _.each(list, function(elem) {
                var modelId = $(elem).attr('data-model-id');
                this.attachSubViewWithModel(this.model.get(modelId), elem);
            }, this);
            this.$el.data('server-rendered', false);
        }
        return this;
    }
});
export default RenderedCollectionView;

